module.exports = __webpack_public_path__ + "img/classroom-enabled.ae1a485b.jpg";